<template>
    <v-container class="px-0">
        <v-data-table :headers="headerConsume" :items="itemsConsume" @pagination="applyPagination"
            :server-items-length="totalItemsLength" :items-per-page.sync="itemsPerPage" :page.sync="page"
            :server-items="loadData" :loading="loading" class="elevation-1" :footer-props="{
                'disable-items-per-page': true,
            }">
        </v-data-table>
    </v-container>
</template>

<script>
export default {
    name: 'AiConsumption',
    data() {
        return {
            page: 1,
            itemsPerPage: 10,
            totalItemsLength: 0,
            loading: true,
            headerConsume: [
                { text: this.$t('id'), value: 'id' },
                { text: this.$t('object'), value: 'object' },
                { text: this.$t('model'), value: 'model' },
                { text: this.$t('promptTokens'), value: 'promptTokens' },
                { text: this.$t('completionTokens'), value: 'completionTokens' },
                { text: this.$t('totalTokens'), value: 'totalTokens' },
                { text: this.$t('additionalDetail'), value: 'additionalDetail' },
                { text: this.$t('dateTime'), value: 'dateAdded' },
            ],
            itemsConsume: [],
        }
    },
    methods: {
        applyPagination() {
            this.loadData();
        },
        loadData() {
            this.loading = true;
            this.$store.dispatch('dashboard/applyLoading')
            const obj = {
                page: this.page,
                itemsPerPage: this.itemsPerPage
            }
            this.$store.dispatch('user/fetchTokenComsumeServerSide', obj)
                .then((response) => {
                    this.$store.dispatch('dashboard/cancelLoading')
                    this.itemsConsume = response.data.responseMsg;
                    this.totalItemsLength = response.data.count
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err)
                    this.loading = false;
                })
        },
    },
}
</script>